<div class="sgp-timeline-row">
    <div class="sgp-step" *ngFor="let step of childrenSteps;let indx = index">
        <div class="sgp-step-title ecl-u-type-color-primary-140">
            {{step?.title}}
        </div>
        <div class="sgp-step__indicator-wrapper"
             [class.sgp-step__indicator-wrapper-disabled]=" step?.isChecked===false"
             [class.sgp-step__indicator-wrapper-end]="contentAlign === 'end'"
        ></div>
        <div class="sgp-step__bullet-item"
             [class.sgp-step__bullet-item-checked]="step?.isChecked === true"
             [class.sgp-step__bullet-item-end]="contentAlign === 'end'"
             [class.sgp-step__bullet-item-blue-theme]="theme === 'blue'"
             [class.sgp-step__bullet-item-disabled]="step?.isActive === false && indx > 0"
        >
            <ecl-icon icon="check" *ngIf="step?.isChecked === true"></ecl-icon>
        </div>

        <div class="sgp-step__label-wrapper">
            <div class="sgp-step__label-wrapper-label ecl-u-mt-m"
                 [class.sgp-step__label-wrapper-label-end]="contentAlign === 'end'"
                 [class.sgp-step__label-wrapper-label-disabled]="step?.isActive === false && indx > 0"
            >
                <span eclLink class="ecl-u-bold ecl-u-type-color-primary-140"
                      *ngIf="!step?.labelRouteRef && !step?.labelLinkRef && !step?.labelModalId">
                    {{step?.label | translate}}
                </span>
                <a [routerLink]="step?.labelRouteRef" eclLink class="ecl-u-bold ecl-u-type-color-primary-140"
                   *ngIf="step?.labelRouteRef">
                    {{step?.label | translate}}
                </a>
                <a [href]="step?.labelLinkRef" eclLink class="ecl-u-bold ecl-u-type-color-primary-140"
                   *ngIf="step?.labelLinkRef">
                    {{step?.label | translate}}
                </a>
                <a tabindex="0" class="ecl-u-type-underline ecl-u-bold ecl-u-type-color-primary-140"
                   (keypress)="openModal(step?.labelModalId)" (click)="openModal(step?.labelModalId)" eclLink
                   *ngIf="step?.labelModalId">
                    {{step?.label | translate}}
                </a>
            </div>
            <div class="sgp-step__label-wrapper-sub-label">
                <p class="ecl-u-type-paragraph-s">
                    {{step?.subLabel | translate}}
                </p>
            </div>
        </div>
    </div>
</div>
